import _classCallCheck from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Qualifier } from "../../internal/qualifier/Qualifier";
import { Action } from "../../internal/Action";
import { toFloatAsString } from "../../internal/utils/toFloatAsString";
import { AspectRatioQualifierValue } from "../../qualifiers/aspectRatio/AspectRatioQualifierValue";
import { regionRelative as _regionRelative, relative as _relative } from "../../qualifiers/flag";
import { FlagQualifier } from "../../qualifiers/flag/FlagQualifier";
/**
 * @description Defines a resize using width and height.
 * @extends SDK.Action
 * @memberOf Actions.Resize
 * @see Visit {@link Actions.Resize| Resize} for examples
 */

var ResizeSimpleAction = /*#__PURE__*/function (_Action) {
  _inherits(ResizeSimpleAction, _Action);

  var _super = _createSuper(ResizeSimpleAction);

  /**
   * @param {string} cropType
   * @param {number | string} cropWidth The required width of a transformed asset.
   * @param {number | string} cropHeight The required height of a transformed asset.
   */
  function ResizeSimpleAction(cropType, cropWidth, cropHeight) {
    var _this;

    _classCallCheck(this, ResizeSimpleAction);

    _this = _super.call(this);

    if (cropWidth) {
      _this.addQualifier(new Qualifier('w', cropWidth));
    }

    if (cropHeight) {
      _this.addQualifier(new Qualifier('h', cropHeight));
    }

    _this.addQualifier(new Qualifier('c', cropType));

    return _this;
  }
  /**
   * @description Sets the height of the resize
   * @param {string | number} x The height in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */


  _createClass(ResizeSimpleAction, [{
    key: "height",
    value: function height(x) {
      return this.addQualifier(new Qualifier('h', x));
    }
    /**
     * @description Sets the width of the resize
     * @param {string | number} x The width in pixels (if an integer is specified) or as a percentage (if a float is specified).
     */

  }, {
    key: "width",
    value: function width(x) {
      return this.addQualifier(new Qualifier('w', x));
    }
    /**
     * @description Sets the aspect ratio of the asset.
     * For a list of supported types see {@link Qualifiers.AspectRatio |
      * AspectRatio values}
     * @param {number|string} ratio The new aspect ratio, specified as a percentage or ratio.
     * @return {this}
     */

  }, {
    key: "aspectRatio",
    value: function aspectRatio(ratio) {
      // toFloatAsString is used to ensure 1 turns into 1.0
      if (ratio instanceof AspectRatioQualifierValue) {
        return this.addQualifier(new Qualifier('ar', ratio));
      }

      if (typeof ratio === 'number' || typeof ratio === 'string') {
        return this.addQualifier(new Qualifier('ar', toFloatAsString(ratio)));
      }

      if (ratio instanceof FlagQualifier) {
        return this.addFlag(ratio);
      }
    }
    /**
     * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the containing image instead of the added layer.
     * @return {this}
     */

  }, {
    key: "relative",
    value: function relative() {
      return this.addFlag(_relative());
    }
    /**
     * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the overlaid region
     * @return {this}
     */

  }, {
    key: "regionRelative",
    value: function regionRelative() {
      return this.addFlag(_regionRelative());
    }
  }]);

  return ResizeSimpleAction;
}(Action);

export default ResizeSimpleAction;